import { WidgetsTypeEnum } from "src/app/enums/widgets/widgets-type.enum";
import { WidgetsAbstract } from "../../abstract/widgets/widgets.abstract";

export class WidgetsTextModel extends WidgetsAbstract {
    readonly icon: string = 'crop_16_9';
    readonly widgetType: WidgetsTypeEnum = WidgetsTypeEnum.TEXT;
    readonly badge: string = 'T';
    readonly placeholderClassName: string = 'column-placeholder';
    
    name: string = 'Text';
    label:string = 'Text';
    template:string = '';
    type: string = 'header';
    level:number = 1;
    
    toJSON() : any {
        return {
            badge: this.badge,
            widgetType: this.widgetType, 
            id: this.id,
            parentId: this.parentId ? this.parentId : undefined,
            name: this.name,
            template: this.template,

            type: this.type, 
            level: this.level, 
            label: this.label 
        };
    }

    /**
     * Clone from a provided origin.
     * @note Id/uuid is not cloned * 
     * @param origin
     * @returns the cloned node
     */
     cloneFrom(origin: WidgetsTextModel) : WidgetsTextModel {
        this.name = origin.name;        
        if (origin.label) {
            this.label = origin.label;
        }
        if (origin.template) {
            this.template = origin.template;
        }        
        if (origin.parentId) {
            this.parentId = origin.parentId;
        }
        this.type = origin.type;
        this.level = origin.level;
        this.isSelected = origin.isSelected;
        return this;
    }
}
